import { Box } from '@ovComponents/1-primative/box/box';
import { Skeleton } from '@ovComponents/1-primative/skeleton/skeleton';
import type { FC, ReactNode } from 'react';

export type TradeFlowPipelineSkeletonProps = {
  stageCount: number;
  header: ReactNode;
};

export const TradeFlowPipelineSkeleton: FC<TradeFlowPipelineSkeletonProps> = ({
  stageCount,
  header,
}) => {
  const count = stageCount || 4;

  return (
    <Box display='flex' flexDirection='column' gap={1}>
      {header}
      <Box display='grid' gridTemplateColumns={`repeat(${count}, 1fr)`} gap={1}>
        {Array.from({ length: count }, (_, i) => (
          <Skeleton key={i} variant='rectangular' height={108} />
        ))}
      </Box>
    </Box>
  );
};
